<script setup lang="ts">
import { type Color, getColorValue } from '@global-types/colors';

withDefaults(defineProps<{
  count: number,
  size?: number,
  color?: Color,
}>(), {
  size: 24,
  color: 'blue',
});
</script>

<template>
  <div
    class="counter-pill"
    :style="{ borderRadius: `${size}px` }"
  >
    <div
      class="counter-pill__content"
      :style="{ minWidth: `${size}px`, height: `${size}px`, backgroundColor: getColorValue(color) }"
    >
      +{{ count }}
    </div>
  </div>
</template>
